package org.zest.insan_360_website.data.page_states

import kotlinx.browser.sessionStorage
import com.varabyte.kobweb.browser.storage.removeItem
import org.zest.insan_360_website.data.page_states.dashboard.AdminsDashboardState
import org.zest.insan_360_website.data.page_states.dashboard.CreditsDashboardState
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState
import org.zest.insan_360_website.data.page_states.dashboard.ReportDashPageState
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState
import org.zest.insan_360_website.pages.USER_QUESTION_INDEX_KEY

fun clearAllStates() {
    MainDashPageState.reset()
    ReportDashPageState.reset()
    StudentsDashboardState.reset()
    AdminsDashboardState.reset()
    CreditsDashboardState.reset()
    MaintenanceState.reset()

    CreditState.reset()
    AssessmentPageState.reset()
    ResultPageState.reset()
    LoginPageState.reset()
    SignUpPageState.reset()

    sessionStorage.removeItem(USER_QUESTION_INDEX_KEY)
}
